import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { TaskServiceInterface } from './definitions/task-service-interface';
import { Observable } from 'rxjs';
import { ErrorsInterface } from '../errors/errors-interface';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface AssumeTaskResponse {
  task: {
    assume: {
      output: TaskServiceInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class AssumeTaskService {
  constructor(private apollo: Apollo) {}

  assume(
    taskId,
    mutation: DocumentNode
  ): Observable<FetchResult<AssumeTaskResponse>> {
    return this.apollo.mutate<AssumeTaskResponse>({
      mutation: mutation,
      variables: {
        taskId,
      },
    });
  }
}
